import MagneticInsectVideo from "../../assets/ProductsVideo/magneticinsect.mp4";
import PatioSpaceVideo from "../../assets/ProductsVideo/PatioSpace.mp4";
import RemovableFrameVideo from "../../assets/ProductsVideo/removableframe.mp4";
import OpenableDoubleDrVideo from "../../assets/ProductsVideo/openabledoubledr.mp4";
import OpenableSingleDrVideo from "../../assets/ProductsVideo/openablesingledr.mp4";
import OpenableWindowVideo from "../../assets/ProductsVideo/openablewindow.mp4";
import SlidingWindowVideo from "../../assets/ProductsVideo/slidingwindow.mp4";
import MultiSlidingDrVideo from "../../assets/ProductsVideo/multislidingdr.mp4";
import SlidingDoorVideo from "../../assets/ProductsVideo/slidingdoor.mp4";
import RetractableDoubleDrVideo from "../../assets/ProductsVideo/rollerdoubledr.mp4";
import RollerWindowVideo from "../../assets/ProductsVideo/Roller window.mp4";
import RollerDrVideo from "../../assets/ProductsVideo/rollerdr.mp4";

import MagneticNetImg from "../../assets/home/magneticnet.webp";
import PatioSpaceImg from "../../assets/home/patiospace.webp";
import RetractableDoubleDoorImg from "../../assets/home/retractabledoubledoor.webp";
import RollerDoorImg from "../../assets/home/rollerdoor.webp";
import RollerWindowImg from "../../assets/home/rollerwindow.webp";
import SlidingWindowImg from "../../assets/home/slidingwindow.webp";
import MultiSlidingDoorImg from "../../assets/home/multislidingdoor.webp";
import SlidingDoorImg from "../../assets/home/slidingdoor.webp";
import OpenableWindowImg from "../../assets/home/openablewindow.webp";
import OpenableSingleDoorImg from "../../assets/home/openablesingledoor.webp";
import OpenableDoubleDoorImg from "../../assets/home/openabledoubledoor.webp";
import RemovableFrameImg from "../../assets/home/removableframe.webp";

// Product categories, in the order they appear on the site.
export const categories = [
  {
    id: "magnetic",
    name: "Magnetic Net",
    description: "Magnetic insect screens and framed mesh for windows and patio spaces.",
  },
  {
    id: "retractable",
    name: "Retractable Systems",
    description: "Roller screens that retract out of sight when you don't need them.",
  },
  {
    id: "sliding",
    name: "Sliding Systems",
    description: "Sliding mesh doors and windows that run on their own track.",
  },
  {
    id: "openable",
    name: "Openable Systems",
    description: "Hinged mesh doors and windows, custom made for existing frames.",
  },
];

// Every product page is rendered by ProductPage from one entry here.
//
// path      URL of the page
// name      product name (also sent with call back requests)
// category  id from `categories`
// image     card photo used on listings
// video     product video
// summary   intro paragraph
// note      intro line shown in place of a paragraph
// points    intro bullet list
// sections  titled bullet lists (Features, Advantages, ...)
// colors    available colour options
const products = [
  {
    path: "/magneticinsectscreens",
    name: "Magnetic Insect Screens",
    category: "magnetic",
    image: MagneticNetImg,
    video: MagneticInsectVideo,
    summary:
      "Magnetic insect screen is fabricated with fiberglass mesh. It is specifically designed to fit existing wooden, aluminum and UPVC windows. Using a flexible magnetic strip with fiberglass mesh, they create a complete seal around the window.",
    sections: [
      {
        title: "Features",
        points: [
          "Easy to clean and reattach it back to on window",
          "No wrinkles on the mesh",
          "No dust accumulation due to no static charge in fiberglass mesh",
          "Does not sag",
        ],
      },
    ],
    colors: ["Black", "White"],
  },
  {
    path: "/PatioSpace",
    name: "Stainless Mesh with Frame for Patio Space",
    category: "magnetic",
    image: PatioSpaceImg,
    video: PatioSpaceVideo,
    points: [
      "This is a custom-made product",
      "This system is mainly installed in your patio space.",
      "It is fabricated with aluminum one inch profile and 304 grade SS stainless steel mesh",
    ],
    sections: [
      {
        title: "Advantages",
        points: [
          "Our system is custom made as per the client’s requirement",
          "Reptile free",
          "The mesh is rodent free",
        ],
      },
    ],
    colors: ["Bronze", "White"],
  },
  {
    path: "/retractabledoubledoor",
    name: "Retractable Double Door System",
    category: "retractable",
    image: RetractableDoubleDoorImg,
    video: RetractableDoubleDrVideo,
    points: [
      "Our specialty is producing top-notch double doors that may be installed on your existing French doors.",
      "This system can only be designed with fiber glass mesh (stiff mesh)",
      "The largest size that may be produced is 3metre by 3.5metre in height and width.",
      "This mechanism has a magnet in the middle to secure it.",
    ],
    sections: [
      {
        title: "Features",
        points: [
          "Mounted vertically on the left and right sides using a 2-inch box section",
        ],
      },
      {
        title: "Advantages",
        points: [
          "Easy to operate",
          "Hassel free",
          "It does not take any additional space.",
        ],
      },
    ],
    colors: ["White", "Bronze"],
  },
  {
    path: "/rollerdoubledoor",
    name: "Retractable Roller Door System",
    category: "retractable",
    image: RollerDoorImg,
    video: RollerDrVideo,
    points: [
      "Retractable Roller Door System is specifically designed to fit the existing doors.",
      "This product can be installed on already-existing backyard, balcony and utility doors.",
      "This system is compatible with any type of door, whether it is made of wood, UPVC or aluminum.",
      "Fiberglass mesh (stiff mesh) and aluminum profiles are used in the fabrication of the system. Every time you use the system, a brush is incorporated to clean the mesh.",
    ],
    sections: [
      {
        title: "Advantages",
        points: [
          "It is a system that doesn't take up much space.",
          "It's quite simple to use, provides a high level of transparency in the mesh and has a nice sturdy appearance.",
          "This system is compatible with any type of door, whether it is made of wood, UPVC or aluminum.",
          "It can be operated from left to right or right to left.",
        ],
      },
    ],
    colors: ["White", "Bronze", "Wood finish"],
  },
  {
    path: "/rollerwindow",
    name: "Retractable Roller Window",
    category: "retractable",
    image: RollerWindowImg,
    video: RollerWindowVideo,
    summary:
      "This product is manufactured with aluminum profiles and fiber glass mesh. It is designed to mount on wooden, aluminum and UPVC windows.",
    sections: [
      {
        title: "Features",
        points: [
          "This retractable roller window can be used only when required.",
          "It has a brush to clean the mesh every time the system is operated.",
          "This system comes with fiberglass mesh only.",
        ],
      },
    ],
    colors: ["Bronze anodized"],
  },
  {
    path: "/slidingwindowsystem",
    name: "Sliding Window System",
    category: "sliding",
    image: SlidingWindowImg,
    video: SlidingWindowVideo,
    summary:
      "The sliding window is a feasible system which can be installed to your existing sliding window or we have an option of creating a track adjacent to your sliding system. You may install this system both inside and outside of your home.",
    sections: [
      {
        title: "Features",
        points: [
          "Hassle-free system",
          "No screws are fixed",
          "The mesh is made of 304-grade stainless steel, which is rust-free and durable.",
          "Our sliding system has felt grove to ensure that there are no spaces between the mesh track and the glass track.",
        ],
      },
    ],
    colors: ["White", "Bronze", "Wood finish"],
  },
  {
    path: "/multislidingdr",
    name: "Multi Sliding Door System",
    category: "sliding",
    image: MultiSlidingDoorImg,
    video: MultiSlidingDrVideo,
    points: [
      "It is constructed from 2-inch aluminum profile and 304-grade stainless steel mesh.",
      "In order to close gaps in the contact surface, it has felt grove. Double screw joints are used during assembly to prevent twisting in the frame and breaking of the edges.",
      "It is advisable to install this type of sliding door on your aluminum and UPVC multi-sliding doors.",
      "With an extra track, this can be installed next to your current multi-sliding glass door.",
      "Reinforcement is given in the center to ensure steadiness of the frame and stiffness of the mesh.",
    ],
    sections: [
      {
        title: "Advantages",
        points: [
          "Given that SS Mesh is being used, it will be rodent-free.",
          "Our system's mesh is exceptionally stiff and steady.",
        ],
      },
    ],
    colors: ["White", "Bronze", "Wood finish"],
  },
  {
    path: "/slidingdoor",
    name: "Sliding Door System",
    category: "sliding",
    image: SlidingDoorImg,
    video: SlidingDoorVideo,
    points: [
      "Aluminum two-inch profiles are used to make the sliding door system.",
      "This system can be built to fit your exact specifications based on the sliding door system you currently have.",
      "This framework may be installed on your current track or a new track can be built next to your sliding door system.",
      "It comes with grade 304 stainless steel mesh.",
    ],
    sections: [
      {
        title: "Features",
        points: [
          "Both the mechanism and the mesh have high durability.",
          "The system has a very high degree of transparency since the mesh is firmly and tightly attached to the profile.",
        ],
      },
    ],
    colors: ["White", "Bronze", "Wood finish"],
  },
  {
    path: "/openablewindow",
    name: "Openable Window System",
    category: "openable",
    image: OpenableWindowImg,
    video: OpenableWindowVideo,
    points: [
      "Openable window system can be installed to your wooden windows and casement window in UPVC.",
      "The system is specially designed with screw joints to all four edges of the window frame.",
      "We use SS 304 grade mesh.",
      "This system is mounted with nylon hinges.",
      "Our system of mounting the mesh to the window is different from what is available in the market.",
    ],
    sections: [
      {
        title: "Features",
        points: [
          "The mesh remains stiff and steady.",
          "Easy to operate.",
          "Easy to wash and re-attach back on your window.",
        ],
      },
    ],
    colors: ["Bronze anodized", "Powder coated white"],
  },
  {
    path: "/openablesingledr",
    name: "Openable Single Door System",
    category: "openable",
    image: OpenableSingleDoorImg,
    video: OpenableSingleDrVideo,
    points: [
      "Openable doors are custom made for the existing utility door, main door and balcony door.",
      "This product is mounted adjacent to your existing doors.",
      "It is assembled together by using a 2inch aluminum profile, double SS screw joints, and rust-free SS 304 mesh.",
      "This system sticks on the magnet while closing.",
    ],
    sections: [
      {
        title: "Features",
        points: [
          "Rust Free",
          "Durability",
        ],
      },
      {
        title: "Advantages",
        points: [
          "This system has removable hinges",
          "It can be washed easily and fixed back without any issue",
          "Excellent airflow as this system is specifically used for main doors, utility doors and balcony doors.",
        ],
      },
    ],
    colors: ["White", "Bronze", "Wood finish"],
  },
  {
    path: "/openabledoubledoor",
    name: "Openable Double Door System",
    category: "openable",
    image: OpenableDoubleDoorImg,
    video: OpenableDoubleDrVideo,
    points: [
      "Custom made for the existing main door, utility door and balcony door.",
      "It has a felt grove to stop gaps in the contact surface and is constructed from a 2-inch aluminum profile with SS 304 mesh.",
      "This system is recommended for doors having width above 4 feet.",
    ],
    sections: [
      {
        title: "Advantages",
        points: [
          "Simple to use; You can take the system apart from the hinges to wash and re-attach.",
        ],
      },
    ],
    colors: ["White", "Bronze", "Wood finish"],
  },
  {
    path: "/RemovableFrame",
    name: "Quick Removable Frame with Magnet",
    category: "openable",
    image: RemovableFrameImg,
    video: RemovableFrameVideo,
    note:
      "This Product is fabricated with one inch profile along with SS 304 grade mesh",
    sections: [
      {
        title: "Features",
        points: [
          "This system can be removed and re-attached easily",
          "It can be wash and dried in sunlight for certain duration.",
        ],
      },
    ],
    colors: ["Bronze", "White"],
  },
];

export function productsIn(categoryId) {
  return products.filter((product) => product.category === categoryId);
}

export default products;
